import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { ProductCategoryData, ProductCategoryResponse } from "../types/productCategories";

const useProductCategory: (id: string) => UseQueryResult<ProductCategoryData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<ProductCategoryResponse, unknown, ProductCategoryData>({
    queryKey: ['productCategory'],
    queryFn: () => privateAxios.get(`/product_categories/${id}`),
    select: (data) => data?.data?.data
  });
}

export default useProductCategory